import { NavigationCSSStyle } from './navigationcss';

import { UIComponentViewImpl } from '../../toolkit/uicomponentview';
import { UIDataModel, UIComponentProps, UIComponentState } from '../../toolkit/uicomponent';
import { RoutingFeatures } from './routingfeature';
import { MainWrapperComponent, MainWrapperComponentProps } from '../mainwrappercomponent';
import { NavigationComponentHandler } from './navigationcomponent';
import { BannerDto } from '../../../core/dto/banner/bannerdto';
import { ToneDto } from '../../../core/dto/tonedto';
import * as React from 'react';
import { Router, Switch, Route, Redirect } from 'react-router';
import { LoginWrapperComponent } from '../login/loginwrappercomponent';
import { LoginComponent } from '../login/login/logincomponent';
import { HomeWrapperComponent } from '../home/homewrappercomponent';
import { HomeComponent } from '../home/home/homecomponent';
import { WishlistComponent } from '../home/wishlist/wishlistcomponent';
import { TransactionHistoryComponent } from '../home/transactionhistory/transactionhistorylistcomponent';
import { FAQComponent } from '../home/faq/faqcomponent';
import { DoItYourselfComponent } from '../home/doityourself/doityourselfcomponent';
import { MyAccountComponent } from '../myaccount/myaccountcomponent';
import { CategoriesListComponent } from '../home/categorieslist/categorieslistcomponent';
import { PlaylistDetailsComponent } from '../home/playlistdetails/playlistdetailscomponent';
import { SearchComponent } from '../home/search/searchcomponent';
import { BannerListComponent } from '../home/banner/bannerlist/bannerlistcomponent';
import { TunesComponent } from '../home/tunes/tunescomponent';
import { GroupComponent } from '../home/groups/groupcomponent';
import { ArtistSearchListComponent } from '../home/searchlist/artist/artistlistcomponent';
import { BlacklistComponent } from '../home/blacklist/blacklistcomponent';
import { NameTunesComponent } from '../nametunes/nametunescomponent';
import { SearchListComponent } from '../home/searchlist/searchlistcomponent';
import { LandingPageComponent } from '../landingpage/landingpagecomponent';
import { ErrorComponent } from './error/errorcomponent';
import { DefaultComponent } from './default/defaultcomponent';

import { ShowMoreFeaturedCategoryComponent } from '../home/featuredcategory/showmorefeaturedcategory/showmorefeaturedcategorycomponent';
import { TermsandConditionComponent } from '../home/termsandcondition/termsandconditioncomponent';



export class NavigationViewImpl extends UIComponentViewImpl<UIDataModel>
{
    selectChildComponentRef: MainWrapperComponent<MainWrapperComponentProps, UIComponentState>;

    bindHandlers()
    {
        this.routeNextFeature = this.routeNextFeature.bind(this);
        this.onSignIn = this.onSignIn.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCategoryClick = this.onCategoryClick.bind(this);
        this.onBannerClick = this.onBannerClick.bind(this);
        this.onPlaylistClick = this.onPlaylistClick.bind(this);
        this.onArtistSearch = this.onArtistSearch.bind(this);
    }

    draw(props: UIComponentProps, state: UIComponentState, cssStyle: NavigationCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <Router history={props.context.getRouterHistory()}>
              <Switch>
                 <Redirect from="/:url*(/+)" to={window.location.pathname.slice(0, -1)+window.location.search} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.LOGIN} render={() => this.getComponent(RoutingFeatures.LOGIN)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.HOME} render={() => this.getComponent(RoutingFeatures.HOME)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.MENU_CATEGROIES} render={() => this.getComponent(RoutingFeatures.MENU_CATEGROIES)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.SEARCH} render={() => this.getComponent(RoutingFeatures.SEARCH)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.BANNER_SEARCH} render={() => this.getComponent(RoutingFeatures.BANNER_SEARCH)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.PROFILE} render={() => this.getComponent(RoutingFeatures.PROFILE)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.WISHLIST} render={() => this.getComponent(RoutingFeatures.WISHLIST)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.FAQ} render={() => this.getComponent(RoutingFeatures.FAQ)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.TERMS_AND_CONDITION} render={() => this.getComponent(RoutingFeatures.TERMS_AND_CONDITION)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.TRANSACTION_HISTORY} render={() => this.getComponent(RoutingFeatures.TRANSACTION_HISTORY)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.DO_IT_YOURSELF} render={() => this.getComponent(RoutingFeatures.DO_IT_YOURSELF)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.PLAYLIST} render={() => this.getComponent(RoutingFeatures.PLAYLIST)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.MYTUNES} render={() => this.getComponent(RoutingFeatures.MYTUNES)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.FEATURED_CATEGROIES} render={() => this.getComponent(RoutingFeatures.FEATURED_CATEGROIES)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.CALLER_GROUP} render={() => this.getComponent(RoutingFeatures.CALLER_GROUP)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.ARTIST_SEARCH} render={() => this.getComponent(RoutingFeatures.ARTIST_SEARCH)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.BLACKLIST} render={() => this.getComponent(RoutingFeatures.BLACKLIST)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.NAME_TUNES} render={() => this.getComponent(RoutingFeatures.NAME_TUNES)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.SEARCH_LIST} render={() => this.getComponent(RoutingFeatures.SEARCH_LIST)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.LANDING_PAGE} render={() => this.getComponent(RoutingFeatures.LANDING_PAGE)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.ERROR} render={() => this.getComponent(RoutingFeatures.ERROR)} />
                <Route exact={true} path={props.context.getRoutingPath() + "/" + RoutingFeatures.FORBIDDEN} render={() => this.getComponent(RoutingFeatures.FORBIDDEN)} />
                <Route exact={true} path={props.context.getRoutingPath()} render={() => this.getComponent(RoutingFeatures.DEFAULT)} />
                <Route render={() => this.getComponent(RoutingFeatures.NOT_FOUND)} />
                </Switch>
            </Router>
            );
        }
        
    private getComponent(routingFeature: string)
    {
        try
        {
        switch(routingFeature)
        {
            case RoutingFeatures.LOGIN:
            {
            return <LoginWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} childComponent={<LoginComponent routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }
            
            case RoutingFeatures.HOME:
            {
                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<HomeComponent  isBannerRequired={false} isNavigationPathRequired={true} onBannerClick={this.onBannerClick} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

            case RoutingFeatures.WISHLIST:
            {
                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick}  routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<WishlistComponent isBannerRequired={true} isNavigationPathRequired={true} onPlaylistClick={this.onPlaylistClick} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

            case RoutingFeatures.MYTUNES:
            {
                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<TunesComponent isBannerRequired={true} isNavigationPathRequired={true} onPlaylistClick={this.onPlaylistClick} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

        
            case RoutingFeatures.TRANSACTION_HISTORY:
            {
                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<TransactionHistoryComponent isBannerRequired={true} isNavigationPathRequired={true} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

            case RoutingFeatures.FEATURED_CATEGROIES:
            {
                let params = this.parseQueryParameters();

                let identifierParam = params.get("identifier");
                let identifier = identifierParam !== null ? identifierParam : "";

                let titleParam = params.get("title");
                let title = titleParam !== null ? titleParam : "";
                
                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<ShowMoreFeaturedCategoryComponent isBannerRequired={true} isNavigationPathRequired={true} identifier={identifier} title={title} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

            case RoutingFeatures.CALLER_GROUP:
                {
                    return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<GroupComponent isBannerRequired={true} isNavigationPathRequired={true} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
                }

            case RoutingFeatures.BLACKLIST:
                {
                    return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<BlacklistComponent isBannerRequired={true} isNavigationPathRequired={true} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
                }
                case RoutingFeatures.NAME_TUNES:
                    {
                        let params = this.parseQueryParameters().get("searchkey");
                        let searchKey = params !== null ? params : "";
        
                        return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<NameTunesComponent isBannerRequired={false} isNavigationPathRequired={false} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} searchKey={searchKey} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
                    }
                    case RoutingFeatures.BLACKLIST:
                    {
                        return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<BlacklistComponent isBannerRequired={true} isNavigationPathRequired={true} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
                    }
            case RoutingFeatures.SEARCH_LIST:
                        {
                            let params = this.parseQueryParameters();

                            let searchKeyParam = params.get("searchkey");

                            let searchKey = searchKeyParam !== null ? searchKeyParam : "";
                            let typeParam = params.get("type");
                            let type = typeParam !== null ? typeParam : "";
            
                            return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<SearchListComponent isBannerRequired={false} isNavigationPathRequired={false} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} type={type} searchKey={searchKey} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
                        }
            case RoutingFeatures.FAQ:
            {
                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick}  routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<FAQComponent isBannerRequired={false} isNavigationPathRequired={true} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
                
            }
            case RoutingFeatures.TERMS_AND_CONDITION:
                {
                    return <HomeWrapperComponent onCategorySelected={this.onCategoryClick}  routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<TermsandConditionComponent isBannerRequired={false} isNavigationPathRequired={true} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
                   
                }

            case RoutingFeatures.DO_IT_YOURSELF:
            {
                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<DoItYourselfComponent isBannerRequired={true} isNavigationPathRequired={true} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }
            
            // case RoutingFeatures.PREVIEW_TONE:
            // {
            //     let params = this.parseQueryParameters().get("tone-id");
            //     let toneId = params !== null ? params : "";

            //     return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<PreviewComponent isBannerRequired={false} isNavigationPathRequired={false} toneId={toneId} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            // }

            case RoutingFeatures.PROFILE:
            {
                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<MyAccountComponent isBannerRequired={false} isNavigationPathRequired={false} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

            case RoutingFeatures.MENU_CATEGROIES:
            {
                let params = this.parseQueryParameters().get("category-name");
                let categoryName = params !== null ? params : "";

                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<CategoriesListComponent isBannerRequired={true} isNavigationPathRequired={true} categoryName={categoryName} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

            case RoutingFeatures.PLAYLIST:
            {
                let params = this.parseQueryParameters().get("playlist-id");
                let categoryName = params !== null ? params : "";

                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<PlaylistDetailsComponent isBannerRequired={false} isNavigationPathRequired={true} onPlaylistClick={this.onPlaylistClick} playlistId={categoryName} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

            case RoutingFeatures.SEARCH:
            {
                let params = this.parseQueryParameters().get("searchkey");
                let searchKey = params !== null ? params : "";

                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={searchKey} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<SearchComponent isBannerRequired={true} isNavigationPathRequired={true} searchKey={searchKey} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

            case RoutingFeatures.ARTIST_SEARCH:
            {
                let params = this.parseQueryParameters().get("searchkey");
                let searchKey = params !== null ? params : "";

                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<ArtistSearchListComponent isBannerRequired={true} isNavigationPathRequired={true} searchKey={searchKey} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

            case RoutingFeatures.BANNER_SEARCH:
            {
                let params = this.parseQueryParameters();

                let bannerOrderParam = params.get("banner-order");
                let bannerOrder = bannerOrderParam !== null ? bannerOrderParam : "";

                let bannerTypeParam = params.get("banner-type");
                let bannerType = bannerTypeParam !== null ? bannerTypeParam : "";

                let searchKeyParam = params.get("searchKey");
                let searchkey = searchKeyParam !== null ? searchKeyParam : "";
                
                return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<BannerListComponent isBannerRequired={true} isNavigationPathRequired={true} searchKey={searchkey} bannerOrder={bannerOrder} bannerType={bannerType} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }

            case RoutingFeatures.LANDING_PAGE:
            {
                return <LandingPageComponent context={this.getUIProps().context}/>;
            }

            case RoutingFeatures.ERROR:
            {
                return <ErrorComponent context={this.getUIProps().context}/>;
            }
            case RoutingFeatures.FORBIDDEN:
            {
                return <DefaultComponent status={"403 Forbidden"} context={this.getUIProps().context}/>;
            }
            case RoutingFeatures.NOT_FOUND:
            {
                return <DefaultComponent status={"404 Not found"} context={this.getUIProps().context}/>;
            }
            default:
            {
                (this.getUIComponentHandler() as NavigationComponentHandler)
              .routeNextFeature(RoutingFeatures.HOME, false);
              return;
                // return <HomeWrapperComponent onCategorySelected={this.onCategoryClick} routeNextFeature={this.routeNextFeature} searchKey={""} onSearch={this.onSearch} signIn={this.onSignIn} childComponent={<HomeComponent  isBannerRequired={false} isNavigationPathRequired={true} onBannerClick={this.onBannerClick} routeNextFeature={this.routeNextFeature} context={this.getUIProps().context} ref={(item: any) => this.selectChildComponentRef = item}/>} context={this.getUIProps().context} />;
            }
        }
        }
        catch(e)
        {
            (this.getUIComponentHandler() as NavigationComponentHandler)
              .routeNextFeature(RoutingFeatures.ERROR, false);

              return;
        }
    }

    private onArtistSearch(searchKey: string): void
    {
        (this.getUIComponentHandler() as NavigationComponentHandler)
              .routeNextFeature(RoutingFeatures.ARTIST_SEARCH + "?searchkey=" + searchKey, false);
    }

    private onSearch(searchKey: string): void
    {
        (this.getUIComponentHandler() as NavigationComponentHandler)
              .routeNextFeature(RoutingFeatures.SEARCH + "?searchkey=" + searchKey, false);
    }

    private onPlaylistClick(playlistDto: ToneDto): void
    {
        (this.getUIComponentHandler() as NavigationComponentHandler)
              .routeNextFeature(RoutingFeatures.PLAYLIST + "?playlist-id=" + playlistDto.getContentId().split("|")[0], false);
    }

    // private onPreviewToneClick(toneDto: ToneDto)
    // {
    //     (this.getUIComponentHandler() as NavigationComponentHandler)
    //     .routeNextFeature(RoutingFeatures.PREVIEW_TONE + "?tone-id=" + toneDto.getId(), false);
    // }

    private onCategoryClick(categoryName: string): void
    {
        (this.getUIComponentHandler() as NavigationComponentHandler)
              .routeNextFeature(RoutingFeatures.MENU_CATEGROIES + "?category-name=" + categoryName, false);
    }

    private onBannerClick(bannerDto: BannerDto): void
    {
        (this.getUIComponentHandler() as NavigationComponentHandler)
              .routeNextFeature(RoutingFeatures.BANNER_SEARCH + "?banner-order=" + 
              bannerDto.getBannerOrder() + "&searchKey=" + bannerDto.getSearchKey() + "&banner-type=" + 
              bannerDto.getType() , false);
    }

    private onSignIn()
    {
        this.routeNextFeature(RoutingFeatures.LOGIN, true);
    }

    private routeNextFeature(routingFeature: RoutingFeatures, isRedirectionRequired: boolean)
    {
        (this.getUIComponentHandler() as NavigationComponentHandler).routeNextFeature(routingFeature, 
            isRedirectionRequired);
    }

    private parseQueryParameters(): URLSearchParams
    {
      return new URLSearchParams(window.location.search);
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/navigationview.tsx